import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { LayoutKeyEnum } from '../../models/enums/layout-key.enum';
import { UserSessionService } from '../../services/user-session.service';

@Component({
    selector: 'sl-gm-dashboard',
    templateUrl: './general-meeting.component.html',
    styleUrls: ['./general-meeting.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralMeetingComponent implements OnInit {
    LayoutKeyEnum = LayoutKeyEnum;
    roleId: number;

    private readonly userSessionService = inject(UserSessionService);

    ngOnInit(): void {
        this.roleId = this.userSessionService.roleId;
    }
}
